import { FC } from 'react';

interface Props {
  size?: number;
  className?: string;
}

const FilledIceCube: FC<Props> = ({ size = 50, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      className={className}
    >
      <path
        d="M31.0441 0.174581C33.5326 -0.438898 36.1307 0.596684 37.5647 2.77423L48.9458 20.0591C49.5306 20.9472 49.8746 21.9564 49.9715 22.9895L25.6511 29.6526L9.66223 6.18861C10.431 5.44934 11.2262 5.06074 12.272 4.80287L31.0441 0.174581Z"
        fill="#9FABFD"
      />
      <path
        d="M25.6511 29.6526L15.633 49.6083C14.4019 49.1554 13.3117 48.3013 12.56 47.1182L0.998962 28.9241C-0.226868 26.9949 -0.33207 24.5325 0.725048 22.5006L8.288 7.96393C8.64166 7.28418 9.1096 6.68504 9.66223 6.18861L25.6511 29.6526Z"
        fill="#5776FC"
      />
      <path
        d="M49.9715 22.9895C50.0735 24.0758 49.9024 25.1871 49.447 26.2128L43.1736 40.3414C42.5672 41.707 41.5116 42.7943 40.2092 43.4265L36.5704 44.598L19.4198 49.7274C18.0959 50.1234 16.8568 50.0916 15.633 49.6083L25.6511 29.6526L49.9715 22.9895Z"
        fill="#7D91FD"
      />
      <path
        d="M39.5854 39.8088C40.03 39.45 40.6737 39.5294 41.0229 39.9861L42.3465 41.7086C42.3465 41.7086 41.952 42.1769 41.6641 42.4395C41.3546 42.7217 40.8138 43.0893 40.8138 43.0893L39.4128 41.2856C39.0635 40.8289 39.1409 40.1676 39.5854 39.8088Z"
        fill="#F4EEFD"
      />
      <path
        d="M33.3294 31.6292C33.7739 31.2704 34.4176 31.3499 34.7669 31.8065L38.3418 36.4807C38.691 36.9373 38.6136 37.598 38.1692 37.9568C37.7246 38.3156 37.0809 38.2368 36.7316 37.7801L33.1574 33.106C32.8082 32.6493 32.8849 31.988 33.3294 31.6292Z"
        fill="#F4EEFD"
      />
      <path
        d="M27.074 23.4502C27.5186 23.0914 28.1623 23.1702 28.5116 23.6269L32.0858 28.301C32.435 28.7577 32.3583 29.419 31.9138 29.7778C31.4693 30.1367 30.8256 30.0571 30.4763 29.6005L26.9014 24.9264C26.5522 24.4697 26.6296 23.809 27.074 23.4502Z"
        fill="#F4EEFD"
      />
      <path
        d="M1.59937 25.053C2.13331 24.8622 2.71652 25.1522 2.9023 25.7007C3.08803 26.2493 2.80581 26.8484 2.27183 27.0392L0.395568 27.7029C0.395568 27.7029 0.189185 27.0841 0.11195 26.6741C0.0355447 26.2686 0.00169493 25.6225 0.00169493 25.6225L1.59937 25.053Z"
        fill="#F4EEFD"
      />
      <path
        d="M9.44757 22.2487C9.9815 22.0579 10.5647 22.3479 10.7505 22.8963C10.9362 23.4449 10.654 24.044 10.12 24.2348L5.63544 25.8376C5.1015 26.0284 4.51829 25.7384 4.33251 25.1899C4.14678 24.6414 4.429 24.0422 4.96298 23.8514L9.44757 22.2487Z"
        fill="#F4EEFD"
      />
      <path
        d="M17.2958 19.4443C17.8297 19.2535 18.4129 19.5435 18.5987 20.092C18.7844 20.6405 18.5022 21.2397 17.9682 21.4305L13.4836 23.0333C12.9497 23.2241 12.3665 22.9341 12.1807 22.3856C11.995 21.837 12.2772 21.2379 12.8112 21.0471L17.2958 19.4443Z"
        fill="#F4EEFD"
      />
      <path
        d="M24.1463 15.1891C24.464 14.709 25.1003 14.5842 25.5678 14.9105C26.0354 15.2368 26.1571 15.8904 25.8397 16.3709L24.5048 18.3892L25.8304 20.1214C26.1797 20.5781 26.1023 21.2394 25.6578 21.5982C25.2132 21.9571 24.5695 21.8776 24.2202 21.4209L22.884 19.6743L21.3318 20.2289C20.7979 20.4197 20.2147 20.1297 20.0289 19.5812C19.8432 19.0327 20.1254 18.4335 20.6594 18.2427L22.5808 17.5553L24.1463 15.1891Z"
        fill="#F4EEFD"
      />
      <path
        d="M30.2883 5.89968C30.6061 5.41951 31.2423 5.29479 31.7099 5.62103C32.1775 5.9473 32.2992 6.60098 31.9818 7.08141L28.4716 12.3903C28.1538 12.8704 27.5176 12.9951 27.05 12.6689C26.5824 12.3426 26.4607 11.689 26.7781 11.2085L30.2883 5.89968Z"
        fill="#F4EEFD"
      />
      <path
        d="M35.9371 1.09599L34.6136 3.1008C34.2959 3.58097 33.6597 3.70569 33.1921 3.37945C32.7245 3.05318 32.6028 2.3995 32.9202 1.91908L34.1571 0.240743C34.1571 0.240743 34.572 0.354178 34.9176 0.51953C35.2699 0.688128 35.9371 1.09599 35.9371 1.09599Z"
        fill="#F4EEFD"
      />
    </svg>
  );
};

export default FilledIceCube;
